import {
    garages
} from '../options';
import { useFilters } from 'shared-components/Components/Filters/Filters.hook';
import { useSearchResultsFilters } from '../../Filters/SearchResultsFilters.hook';
import { useContext } from 'react';
import { ConfigStateContext } from 'shared-components/Contexts/Configurations/context';
import { firstLetterToUppercase } from 'src/utils/Functions';

export const GaragesFilter = () => {
    const { filters } = useFilters();
	const { translations } = useContext(ConfigStateContext);
    const { changeFiltersAndUpdateURL: changeFilters } = useSearchResultsFilters();
    const garageList = garages;

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const currentGarageFilter = filters.garage ?? [];
        const { value, checked } = e?.target;
        const parsedValue = Number(value);
        let updatedGarageFilter = [];

        if (checked) {
            updatedGarageFilter = [...currentGarageFilter, parsedValue];
        } else {
            updatedGarageFilter = currentGarageFilter.filter(b => b !== parsedValue);
        }

        const newGarageFilter = garageList.filter(item => updatedGarageFilter.includes(item.value));

        changeFilters({ garage: newGarageFilter });
    }

    return (
        <div className="otherFilters__container" id="garages">
            <p>{firstLetterToUppercase(translations.garage)}s</p>

            {garageList?.map((val, i) => {
                return (
                    <div
                        key={"garage - " + i}
                        className="otherFilters__container__option">
                        <input
                            type="checkbox"
                            className="checkBoxCustomInput"
                            name="garage"
                            onChange={handleOnChange}
                            id={val.text}
                            checked={
                                typeof filters?.garage !== "undefined" &&
                                filters?.garage.includes(val.value)
                            }
                            value={val.value}
                        />
                        <label htmlFor={val.value.toString()}>{val.value}</label>
                    </div>
                );
            })}
        </div>
    )
}
